import axios from 'axios';
import { API_URL } from '../constants/api';
import { ActiveGameInfo, LiveGameDetail, FieldMap } from '../types/liveGame';

// Получение списка активных игр на поле
export const getActiveGames = async (fieldId: string): Promise<ActiveGameInfo[]> => {
  try {
    const response = await axios.get(`${API_URL}/api/live-games/field/${fieldId}`);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Failed to get active games');
  }
};

// Получение детальной информации об игре
export const getGameDetail = async (gameSessionId: string): Promise<LiveGameDetail> => {
  try {
    const response = await axios.get(`${API_URL}/api/live-games/${gameSessionId}`);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Failed to get game detail');
  }
};

// Получение карт поля
export const getFieldMaps = async (fieldId: string): Promise<FieldMap[]> => {
  try {
    const response = await axios.get(`${API_URL}/api/field-maps/field/${fieldId}`);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Failed to get field maps');
  }
};

// Получение карты по ID
export const getFieldMapById = async (mapId: string): Promise<FieldMap> => {
  try {
    const response = await axios.get(`${API_URL}/api/field-maps/${mapId}`);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Failed to get field map');
  }
};

export default {
  getActiveGames,
  getGameDetail,
  getFieldMaps,
  getFieldMapById,
};
